import React from 'react';

interface Point {
  date: string;
  label: string;
  caTTC: number;
}

interface Props {
  points: Point[];
  /** Hauteur du chart en px (zone des barres). */
  height?: number;
  /** Couleur des barres — currentColor par défaut pour hériter du tenant. */
  color?: string;
}

/**
 * Mini bar chart "volume par jour" — une barre verticale par point.
 * Pensé pour la fenêtre 30j glissants du Dashboard : on veut lire le volume
 * journalier, pas la dérivée (cf. retour Romaric). La dernière barre (aujourd'hui)
 * est pleine opacité, les autres légèrement atténuées pour la mettre en avant.
 * Le SVG est tracé sur une largeur de référence puis étiré à 100% via CSS.
 */
export function BarChartMonth({ points, height = 60, color = 'currentColor' }: Props) {
  if (points.length === 0) return null;
  const width = 343;
  const max = Math.max(...points.map((p) => p.caTTC), 1);
  const n = points.length;
  const gap = 2;
  const barW = (width - gap * (n - 1)) / n;

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="none"
      style={{ display: 'block' }}
      aria-label="Volume journalier 30 jours"
    >
      {points.map((p, i) => {
        const h = Math.max((p.caTTC / max) * height, p.caTTC > 0 ? 2 : 0);
        const x = i * (barW + gap);
        const y = height - h;
        const isLast = i === n - 1;
        return (
          <rect
            key={p.date}
            x={x}
            y={y}
            width={barW}
            height={h}
            rx={1}
            fill={color}
            fillOpacity={isLast ? 1 : 0.35}
          />
        );
      })}
    </svg>
  );
}
